import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';
import { DatePicker, Button, LinkButton, Cell } from '../../atoms';
import {
  ButtonContainer,
  NextShippingContainer,
  Subheading,
  StyledDatePickerForm,
} from './styles';

export const DatePickerForm = ({
  defaultValues,
  onSubmit,
  disabledDates,
  minDate,
  maxDate,
  labelButtonSave,
  labelButtonCancel,
  cancelButtonTarget,
  nextDeliveryLabel,
  nextDeliveryDate,
  isSubmitting,
}) => {
  const { handleSubmit, control } = useForm({
    defaultValues,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <StyledDatePickerForm>
        <NextShippingContainer>
          <Subheading>{nextDeliveryLabel}</Subheading>
          <Subheading subheading="true">{nextDeliveryDate}</Subheading>
        </NextShippingContainer>
        <Cell position="center">
          <Controller
            control={control}
            name="next_delivery_target"
            render={({ field: { ref, value, ...field } }) => (
              <DatePicker
                {...field}
                disabledDates={disabledDates}
                minDate={minDate}
                maxDate={maxDate}
                selected={value}
              />
            )}
          />
        </Cell>
        <Cell>
          <ButtonContainer>
            <Button disabled={isSubmitting} type="submit">
              {labelButtonSave}
            </Button>
            <LinkButton variant="secondary" href={cancelButtonTarget}>
              {labelButtonCancel}
            </LinkButton>
          </ButtonContainer>
        </Cell>
      </StyledDatePickerForm>
    </form>
  );
};

DatePickerForm.displayName = 'DatePickerForm';

DatePickerForm.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disabledDates: PropTypes.array.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  labelButtonSave: PropTypes.string.isRequired,
  labelButtonCancel: PropTypes.string.isRequired,
  cancelButtonTarget: PropTypes.string.isRequired,
  nextDeliveryLabel: PropTypes.string.isRequired,
  nextDeliveryDate: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};
